import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@redux/hook';
import type { RootState } from '@redux/store';
import { useLocation, useNavigate } from 'react-router';
import { ILayoutProps } from '@common/interface';
import Header from './Header';
import Footer from './Footer';
import './styles.css';
import dayjs from 'dayjs';
import { message } from 'antd';
import SuggestionBox from '../SuggestionBox';
import { getProfile } from 'services/GetProfile';
import { logout } from '@redux/features/GeneralReducer';

import { ACCESS_RESTRICT_LINK, PUBLIC_RESTRICT_LINK } from '@common/constants';

const Layout: React.FC<ILayoutProps> = props => {
	const { children, pageInfo, bgClass, includeLayout = true, className } = props;
	const dispatch = useAppDispatch();
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const isLogin = useSelector((state: RootState) => state?.general?.isLogin);
	const { dataId, isResetPassword, status, expiryDate, hasExpiryDate } = useSelector(
		(state: RootState) => state.user
	);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	useEffect(() => {
		if (isLogin) {
			if (isResetPassword) {
				navigate('/reset-password');
			} else {
				if (PUBLIC_RESTRICT_LINK.includes(pathname as (typeof PUBLIC_RESTRICT_LINK)[number])) {
					navigate('/');
				}
			}
		} else {
			if (ACCESS_RESTRICT_LINK.includes(pathname as (typeof ACCESS_RESTRICT_LINK)[number])) {
				navigate('/');
			}
		}
	}, [isLogin]);

	useEffect(() => {
		if (isLogin && dataId !== null && status !== '') {
			if (status !== 'Active' || (hasExpiryDate && dayjs().isAfter(expiryDate))) {
				dispatch(logout());
			}
		}
	}, [isLogin]);

	useEffect(() => {
		try {
			if (dataId !== null) {
				getProfile(dataId, dispatch);
			}
		} catch (error) {
			if (error instanceof Error) {
				message.error(error.message);
			} else {
				message.error('Connect Error.');
			}
		}
	}, []);

	return (
		<div className={`layout ${bgClass}`}>
			{includeLayout && <Header pageInfo={pageInfo} />}
			<main
				className={`layout-content ${!includeLayout ? 'center-content' : ''} ${className || ''}`}
			>
				{children}
			</main>
			{includeLayout && <SuggestionBox />}
			{includeLayout && <Footer />}
		</div>
	);
};

export default Layout;
